import { render } from "./PedidoEmDigitacao.vue?vue&type=template&id=70f1c79c&scoped=true"
import script from "./PedidoEmDigitacao.vue?vue&type=script&lang=js"
export * from "./PedidoEmDigitacao.vue?vue&type=script&lang=js"

import "./PedidoEmDigitacao.vue?vue&type=style&index=0&id=70f1c79c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f1c79c"]])

export default __exports__